import React from 'react';
import Close from 'components/common/Close/Close';
import { white, black40 } from 'styles/common/_constants.scss';
import { useClickOutside, useIsMobile } from 'hooks';
import Button from 'components/common/Button/Button';
import { func } from 'prop-types';

const CancelModal = ({ hide, id }) => {
  const isMobile = useIsMobile();
  const ref = useClickOutside(hide);

  return (
    <div className="cancel-modal" ref={ref}>
      <div className="cancel-modal-header">
        Cancel Movies & Series Creation
        <Close onClick={hide} color={isMobile ? white : black40} />
      </div>
      <div className="layer cancel-modal-header-content">
        <div className="cancel-content-div">
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            Cancel this Movies & Series {`${id ? 'updation' : 'creation'}`}?
          </span>
          <div className="buttons">
            <Button className="cancel-btn" onClick={hide}>
              Go Back
            </Button>
            <Button
              type="primary"
              labelId="Yes, Cancel"
              className="delete-btn"
              onClick={() => window.history.back()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CancelModal.propTypes = {
  hide: func.isRequired
};

export default CancelModal;
